import React from 'react';
import PropTypes from 'prop-types';

function CloseIcon({ title }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      role="img"
      aria-labelledby="close-icon-title"
    >
      <title id="close-icon-title">{title}</title>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g
          className="icon-path"
          fillRule="nonzero"
          transform="translate(-1117 -326)"
        >
          <g transform="translate(1117 326)">
            <g>
              <path d="M19.324 3.94L13.264 10l6.06 6.06a2.308 2.308 0 01-3.263 3.264L10 13.264l-6.06 6.06A2.3 2.3 0 012.307 20a2.308 2.308 0 01-1.631-3.94L6.736 10 .675 3.94A2.308 2.308 0 013.939.675L10 6.736l6.06-6.06a2.308 2.308 0 013.264 3.263z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

CloseIcon.propTypes = {
  title: PropTypes.string.isRequired,
};

export default React.memo(CloseIcon);
